/**************************************************
 * Nombre:       Home_Nueva_Coleccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import '@splidejs/react-splide/css';
import {useContext, useEffect, useState} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {where} from "firebase/firestore";
import {contexApp} from "../../../App";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {TituloTexto} from "./SubComponentes/TituloTexto";
import Tarjeta_Producto_Dos from "../../Tarjetas/Tarjeta_Producto_Dos";

const Home_Nueva_Coleccion = () => {
    const cData = useContext(contexApp)
    const {sCell, masSM} = useResponsive()
    const [coleccion, setColeccion] = useState({})
    const [prendas, prendasets] = useState([])


    useEffect(() => {


        if (cData.actColeccion && cData.actColeccion.id) {
            setColeccion(cData.actColeccion)

            let w = [where('idColeccion', '==', cData.actColeccion.id), where('estado', '==', 'Publicado')]
            obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                if (dox.res) {
                    prendasets(dox.data)
                }
            })

        }


    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <TituloTexto texto={'NUEVA COLECCIÓN'} titulo={coleccion.nombre && coleccion.nombre.toUpperCase()}/>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 10, md: 12}}
                    spacing={2}
                    sx={{mt: 8}}
                >

                    {prendas.map((it, index) => {
                        return (
                            <Grid container key={index + 'p'} size={{xs: 6, sm: 6, md: 2.4}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Producto_Dos item={it}/>
                            </Grid>
                        )
                    })}

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Nueva_Coleccion



